import { createModule } from '@/store/createModule';
import { IMilestone } from '@/models';
import { client } from '@/store';
import { ICRUDResponse } from '@/models';

export const milestone = createModule<IMilestone>('milestone', {
  actions: {
    async getEntities(context, {
      milestoneable_id,
      milestoneable_type
    }) {
      const { data } = await client.get<ICRUDResponse<IMilestone[]>>('milestone', { params: { milestoneable_id, milestoneable_type } })
      return data
    }
  }
});

